module.exports = __webpack_public_path__ + "static/media/electronic-medical-records-software.960badd2.webp";